export default "__VITE_ASSET__wszstjwu__"